<footer class="text-lg-start">
  <div *ngIf="showTopFooter" class="top-footer">
    <!-- Grid container -->
    <div class=" container p-4">
      <!--Grid row-->
      <div class="row">

        <!--Grid column-->
        <div class="col-lg-4 col-md-6 mb-4 mb-lg-0">
          <h5 class="text-uppercase">Footer Content</h5>

          <ul class="list-unstyled mb-0">
            <li>
              <a routerLink="./" class="">Lorem ipsum</a>
            </li>
            <li>
              <a routerLink="./" class="">Ut facilisis</a>
            </li>
            <li>
              <a routerLink="./" class="">Aenean sit</a>
            </li>
          </ul>
        </div>
        <!--Grid column-->

        <!--Grid column-->
        <div class="col-lg-4 col-md-6 mb-4 mb-lg-0">
          <h5 class="text-uppercase">Footer Content</h5>

          <ul class="list-unstyled mb-0">
            <li>
              <a routerLink="./" class="">Suspendisse potenti</a>
            </li>
          </ul>
        </div>
        <!--Grid column-->

        <!--Grid column-->
        <div class="col-lg-4 col-md-12 mb-4 mb-md-0">
          <h5 class="text-uppercase">Footer Content</h5>

          <p>
            Lorem ipsum dolor sit amet consectetur, adipisicing elit. Iste atque ea quis
            molestias. Fugiat pariatur maxime quis culpa corporis vitae repudiandae aliquam
            voluptatem veniam, est atque cumque eum delectus sint!
          </p>
        </div>
        <!--Grid column-->
      </div>
      <!--Grid row-->
    </div>
  </div>
  <!-- Grid container -->

  <!-- Copyright -->
  <div class="bottom-footer p-1 d-flex justify-content-center align-items-center text-white">
    <div class="content-container">
      <ul class="footer-info list-unstyled small d-flex justify-content-center mb-0">
        <li>
          <a class="text-white" href="https://www.adelaide.edu.au/legals/copyright/">
            Copyright
          </a>
        </li>
        <li>
          <a class="text-white" href="javascript:void(0);" (click)="showCookieSettings()">
            {{ 'footer.link.cookies' | translate}}
          </a>
        </li>
        <li *ngIf="showPrivacyPolicy">
          <a class="text-white" href="https://www.adelaide.edu.au/legals/privacy/">
            Privacy Policy
          </a>
        </li>
        <li *ngIf="showEndUserAgreement">
          <a class="text-white" href="https://www.adelaide.edu.au/legals/disclaimer/">
            Disclaimer
          </a>
        </li>
        <li *ngIf="showSendFeedback$ | async">
          <span class="text-white" style="padding-left: 8px; padding-right: 8px;">
            CRICOS Provider Number 00123M
          </span>
        </li>
      </ul>
    </div>
  </div>
  <!-- Copyright -->
</footer>
